<template>
  <f7-navbar :sliding="false">
    <!-- Hier zou back-link="" no-shadow kunnen, maar dat moet dan met slimheid -->
    <template v-slot:right>
      <f7-nav-title>
        <f7-button small panel-toggle="left" class="display-flex" icon-f7="bars"></f7-button>
      </f7-nav-title>
    </template>
    <template v-slot:left>
      <f7-nav-title>
        <!--              Private Gym-->
        <f7-link panel-close="left" href="/">
          <img src="/static/images/logos/private-gym/logo-cropped.svg" class="mt-1 mb-1" style="height: 30px;"/>
        </f7-link>
      </f7-nav-title>
    </template>
<!--    <f7-subnavbar>-->
<!--      <f7-segmented raised>-->
<!--        <f7-button tab-link="#tab1" tab-link-active>Tab 1</f7-button>-->
<!--        <f7-button tab-link="#tab2">Tab 2</f7-button>-->
<!--      </f7-segmented>-->
<!--    </f7-subnavbar>-->

  </f7-navbar>
</template>

<script>

export default {
  components: {},

  props: [],

  mixins: [],

  data: function () {
    return {
      //
    };
  },

  computed: {
    rootUrl() {
      return import.meta.env.PG_ROOT_URL;
    },
  },

  created() {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  },

  watch: {
    //
  }
};
</script>
